  (function(){
    const KX_CSP = window.KX_CSP_CONFIG || {};
    const initSimilarProducts = () => {
      const wrapper = document.querySelector('.custom-similar-products-wrapper');
      if (!wrapper) return;
      
      // Prevent double init
      if(wrapper.dataset.initialized === 'true') return;
      wrapper.dataset.initialized = 'true';
      
      const sectionId = KX_CSP.sectionId;
      const container = document.getElementById('csp-grid-' + sectionId);
      if (!container) return;
  
      const productId = wrapper.dataset.productId;
      const url = `/recommendations/products.json?product_id=${productId}&limit=10`;
  
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.products && data.products.length > 0) {
            container.innerHTML = data.products.map(product => {
               let badgeHtml = '';
               let priceHtml = '';
               
               if (product.compare_at_price > product.price) {
                 const diff = product.compare_at_price - product.price;
                 const percent = Math.round((diff / product.compare_at_price) * 100);
                 badgeHtml = `<div class="csp-badge">-${percent}%</div>`;
                 
                 priceHtml = `
                   <span class="csp-price-container">
                     <span class="csp-price-current">${(product.price / 100).toFixed(2).replace('.', ',')} €</span>
                     <span class="csp-price-old">${(product.compare_at_price / 100).toFixed(2).replace('.', ',')} €</span>
                   </span>
                 `;
               } else {
                 priceHtml = `
                    <span class="csp-price-container">
                      <span class="csp-price-regular">${(product.price / 100).toFixed(2).replace('.', ',')} €</span>
                    </span>
                 `;
               }
               
               const brand = product.vendor || "";
               const title = product.title;
               
               // Robust handle extraction
               let handle = product.handle;
               if (!handle && product.url) {
                 const parts = product.url.split('/');
                 handle = parts[parts.length - 1].split('?')[0]; 
               }
               handle = handle ? handle.trim() : null;
               
               const resizeImage = (url, size) => {
                 try { return url.replace(/(\.[^.]*)$/, `_${size}$1`); } catch(e) { return url; }
               };
               const escapeAttr = (s) => (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');

               // Extract sizes for hover panel
               const sizeOptionIdx = (product.options || []).findIndex(o => /gr[öo]ße|size/i.test(o));
               let sizesHtml = '';
               let firstVariantId = product.variants && product.variants.length ? product.variants[0].id : '';
               if (product.variants) {
                 const avail = product.variants.find(v => v.available);
                 if (avail) firstVariantId = avail.id;
                 if (sizeOptionIdx >= 0) {
                   const sizeKey = 'option' + (sizeOptionIdx + 1);
                   const sizes = [...new Set(product.variants.map(v => v[sizeKey]).filter(Boolean))];
                   const shown = sizes.slice(0, 4);
                   const rest = sizes.length - shown.length;
                   sizesHtml = '<div class="csp-card__hover-sizes">' +
                     shown.map(s => '<span class="csp-card__size-dot">' + s + '</span>').join('') +
                     (rest > 0 ? '<span class="csp-card__size-more">+' + rest + '</span>' : '') +
                     '</div>';
                 }
               }

               // Black-Friday-Badge: IDs + Markup kommen aus snippets/kx-bf-head.liquid (nur im Aktionszeitraum)
               const kxBf = (window.KX_BF && KX_BF.ids && KX_BF.ids.indexOf(product.id) !== -1) ? KX_BF.html : '';

               return `
                 <div class="csp-card" style="position: relative; display: flex; flex-direction: column;">
                   <a href="${product.url}" style="position: absolute; inset: 0; z-index: 1;" aria-label="${escapeAttr(title)}"></a>
                   <div class="csp-image-wrapper">
                      <wishlist-heart data-product-handle="${handle}"></wishlist-heart>
                      ${kxBf}
                      <img src="${resizeImage(product.featured_image, '400x')}" alt="${escapeAttr(title)}" class="csp-image" loading="lazy" width="400" height="400">
                      ${badgeHtml}
                   </div>
                   <div class="csp-info" style="pointer-events: none;">
                     <span class="csp-brand">${brand}</span>
                     <span class="csp-title">${title}</span>
                     ${priceHtml}
                   </div>
                   <div class="csp-card__hover-panel">
                     <a href="${product.url}" class="csp-card__hover-link" aria-label="${escapeAttr(title)}"></a>
                     <div class="csp-image-wrapper">
                       <wishlist-heart data-product-handle="${handle}"></wishlist-heart>
                       ${kxBf}
                       <img src="${resizeImage(product.featured_image, '400x')}" alt="${escapeAttr(title)}" class="csp-image" loading="lazy" width="400" height="400">
                       ${badgeHtml}
                     </div>
                     <div class="csp-card__hover-body">
                       <span class="csp-brand">${brand}</span>
                       <span class="csp-title">${title}</span>
                       ${priceHtml}
                       ${sizesHtml}
                       <button type="button" class="csp-card__hover-atc" data-variant-id="${firstVariantId}">
                         <span class="csp-atc__text">${KX_CSP.addToCartLabel}</span>
                         <span class="csp-atc__check"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
                         <span class="csp-atc__adding"><svg class="csp-atc__spinner" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4" stroke-dashoffset="10"/></svg></span>
                       </button>
                     </div>
                   </div>
                 </div>
               `;
            }).join('');
            
            // Show wrapper now that products are ready
            wrapper.style.display = 'block';

          } else {
            // No Shopify recommendations: keep the server-rendered related
            // products (crawlable fallback) instead of hiding the section.
          }
   
            // Listen for cart updates to hide section if empty
            document.addEventListener('cart:update', (event) => {
               const count = event.detail && event.detail.data && event.detail.data.itemCount;
               const wrapper = document.querySelector('.custom-similar-products-wrapper');
               if (wrapper && (count === 0)) {
                  wrapper.style.display = 'none';
               }
            });
   
        })
        .catch(e => console.error("Error loading similar products:", e));
    };
 
    // Standard init
    if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', initSimilarProducts);
    } else {
       initSimilarProducts();
    }
    // BFCache support
    window.addEventListener('pageshow', (event) => {
       if (event.persisted) initSimilarProducts();
    });

    /* ── AJAX Add to Cart handler for hover panels ── */
    document.addEventListener('click', async function(e) {
      var btn = e.target.closest('.csp-card__hover-atc');
      if (!btn || btn.disabled || btn.classList.contains('is-adding')) return;

      var variantId = btn.getAttribute('data-variant-id');
      var activeCard = btn.closest('.csp-card');
      if (!variantId) return;

      e.preventDefault();
      e.stopPropagation();

      var cspWrapper = document.querySelector('.custom-similar-products-wrapper');
      if (activeCard) activeCard.classList.add('is-atc-active');
      if (cspWrapper) cspWrapper.classList.add('is-atc-active');
      btn.classList.add('is-adding');
      btn.classList.remove('is-added');

      try {
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: formData
        });
        var addedItem = await addRes.json();
        if (!addRes.ok) throw new Error('Add failed');

        btn.classList.remove('is-adding');
        btn.classList.add('is-added');

        var cartDrawer = document.querySelector('cart-drawer-component');
        var drawerSectionId = cartDrawer ? cartDrawer.dataset.sectionId : null;
        var sections = {};
        if (drawerSectionId) {
          var sectionsRes = await fetch(window.location.pathname + '?sections=' + drawerSectionId);
          sections = await sectionsRes.json();
        }
        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'csp-atc',
            data: { sections: sections, itemCount: cart.item_count }
          }
        }));

        setTimeout(function() {
          btn.classList.remove('is-added');
          if (activeCard) activeCard.classList.remove('is-atc-active');
          if (cspWrapper) cspWrapper.classList.remove('is-atc-active');
        }, 2000);

      } catch(err) {
        btn.classList.remove('is-adding');
        btn.textContent = 'Fehler';
        setTimeout(function() {
          btn.innerHTML = '<span class="csp-atc__text">' + KX_CSP.addToCartLabel + '</span><span class="csp-atc__check"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span><span class="csp-atc__adding"><svg class="csp-atc__spinner" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4" stroke-dashoffset="10"/></svg></span>';
          if (activeCard) activeCard.classList.remove('is-atc-active');
          if (cspWrapper) cspWrapper.classList.remove('is-atc-active');
        }, 1500);
      }
    });
  })();
